'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * Link to another account, and/or another app
 *
 * attributes are the followings
 *      - id   : the id of the account to switch to
 *      - path : the path to go to, relative to the target app.
 *      - app-id  : the app to switch to.
 *
 * Example :
 * <link-to-compte id="{{compteId}} url="home" app-id="DETTE">
 *     <span>My link text</span>
 * </link-to-compte>
 *
 */
ngModule.directive("linkToCompte", function ($window, $session, $applications) {
  return {
    restrict: "EA",
    replace: true,
    scope: true,
    transclude: true,
    template: '<a class="compte-link" ng-click="go($event)" href="{{url}}" ng-transclude></a>',
    link: function link($scope, $el, $attrs) {
      var compteId = null,
        appId = $applications.getCurrentAppId(),
        path = "";
      var recomputeUrl = function recomputeUrl() {
        $scope.url = $applications.getApplicationUrl(appId, path, compteId);
      };
      var refreshCompteId = function refreshCompteId(_compteId) {
        compteId = _compteId;
        if (!compteId) {
          var compte = $session.getCompte();
          if (compte != null) {
            compteId = compte.id;
          }
        }
      };
      var refreshAppId = function refreshAppId(_appId) {
        appId = _appId;
        if (!appId) {
          appId = $applications.getCurrentAppId();
          if (appId === "INTRA") {
            appId = "DETTE";
          }
        }
      };
      var refreshPath = function refreshPath(_path) {
        path = _path || "";
      };
      $attrs.$observe("compteId", function (_compteId) {
        refreshCompteId(_compteId);
        recomputeUrl();
      });
      $attrs.$observe("appId", function (_appId) {
        refreshAppId(_appId);
        recomputeUrl();
      });
      $attrs.$observe("path", function (_path) {
        refreshPath(_path);
        recomputeUrl();
      });
      $scope.go = function (event) {
        if (!event.ctrlKey) {
          $window.location.href = $scope.url;
        }
      };
      refreshCompteId();
      refreshAppId();
      refreshPath();
      recomputeUrl();
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/structure/linkToCompte.js
// module id = 3002
// module chunks = 13